module.exports = "/images/safari-pinned-tab.svg?b6def33";


//////////////////
// WEBPACK FOOTER
// ./resources/img/favicon/safari-pinned-tab.svg
// module id = 27
// module chunks = 0